import React, { useState, useEffect, useCallback, memo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import OfficeForm from "./OfficeForm";
import { closeModalDialog } from "../../../../../../actions/layoutActions";
import propTypes from "../../../../../../constants/propTypes";
import {
  performCreateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";

import { LoaderContext } from "../../../../../ui/Loader";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { handleRequestError } from "../../../../../../utils/formValidationUtils";
import { processCreateRequestStatus } from "../../../../../../utils/dataComponentUtils";
import { dataComponentId } from "../OfficesTableContainer";

const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  formikActions
) => {
  processCreateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

export const CreateOfficeContainer = ({
  dataComponent,
  closeModalDialog,
  performCreateRequest,
  loading,
  setReload,
  role,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      formikActions
    );
  });

  const handleCreateOffice = useCallback(
    (office, formikActions) => {
      performCreateRequest(dataComponentId, office);
      setFormikAction(formikActions);
    },
    [performCreateRequest]
  );

  return (
    <LoaderContext.Provider value={{ loading }}>
      <OfficeForm
        onSubmit={handleCreateOffice}
        dataComponentId={dataComponentId}
        role={role}
      />
    </LoaderContext.Provider>
  );
};

CreateOfficeContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  closeModalDialog: PropTypes.func,
  clientId: PropTypes.string,
  performCreateRequest: PropTypes.func,
  setReload: PropTypes.func,
  loading: PropTypes.bool,
  role: propTypes.userRole,
};

export const mapDispatchToProps = {
  closeModalDialog,
  performCreateRequest,
  setReload,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  const {
    auth: { role },
  } = state;
  return {
    dataComponent,
    role,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(CreateOfficeContainer));
